import React from 'react'
import Login from "./pages/Login";
import { Route, Routes } from "react-router-dom";
import { useSelector } from 'react-redux';
import Layout from './pages/Layout';
import NotFound from './pages/NotFound';
import ProtectedRoute from "./pages/ProtectedRoute";
import HomeDashboard from './pages/HomeDashboard';
import EditCategory from './pages/EditCategory';
import AddCategory from './pages/AddCategory';
import Categories from './pages/Categories';
import Products from './pages/Products';
import AddProduct from './pages/AddProduct.jsx';
import EditProduct from './pages/EditProduct';
import AddBanner from './pages/AddBanner';
import Banners from './pages/Banners';
import Users from './pages/Users';
import User from './pages/User.jsx';
import Orders from './pages/Orders.jsx';
import Order from './pages/Order.jsx';


function MainRoute() {
  const auth = useSelector((state) => state.auth.userArray);
  console.log(auth?.access_token);

  return (
    <Routes>
      <Route path="/" element={auth?.access_token ? <Layout /> : <Login />} />
      <Route element={<ProtectedRoute />}>

        <Route path="/dashboard" element={<Layout />}>
          <Route path="/dashboard/Dashboard" element={<HomeDashboard />} />

          <Route path="/dashboard/categories" element={<Categories />} />
          <Route path="/dashboard/add-category" element={<AddCategory />} />
          <Route path="/dashboard/edit-category/:id" element={<EditCategory />} />

          <Route path="/dashboard/products" element={<Products />} />
          <Route path="/dashboard/add-product" element={<AddProduct />} />
          <Route path="/dashboard/edit-product/:id" element={<EditProduct />} />

          <Route path="/dashboard/banners" element={<Banners />} />
          <Route path="/dashboard/add-banner" element={<AddBanner />} />

          <Route path="/dashboard/users" element={<Users />} />
          <Route path="/dashboard/user/:id" element={<User />} />

          <Route path="/dashboard/orders" element={<Orders />} />
          <Route path="/dashboard/order/:id" element={<Order />} />
          {/* <Route path="/dashboard/user/:id" element={<User />} /> */}


        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />

    </Routes>


  )
}

export default MainRoute
